import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Well } from 'react-bootstrap';
import _ from 'lodash';
import currencyConversion from '../../utils/currencyConversion';
import TopTwentyForm from './TopTwentyForm';
import ScheduleFilters from '../common/ScheduleFilters';
import './TopTwenty.less';
import MoneyFormat from '../common/MoneyFormat';
import EditCopyPasteSchedule from '../common/EditCopyPasteSchedule';
import ScheduleVerifyToolbar from '../common/ScheduleVeriyToolbar';

class TopTwenty extends Component {
  getTopTwentydata = (data) => {
    const { creditors = [] } = data;
    const { value_from = '', value_to = '', keyword = '' } = this.props.viewFilters;
    const searchWords = keyword
      .toLowerCase()
      .split(' ')
      .filter((p) => p !== '')
      .reverse();
    const inRange = (value) =>
      (value_from ? currencyConversion.toDollars(value) >= value_from : true) &&
      (value_to ? currencyConversion.toDollars(value) <= value_to : true);
    const filteredCreditors = creditors.map((creditor) => {
      const text = Object.values(creditor).join(' ').toLowerCase();
      const visible =
        (_.isEmpty(searchWords) || _.every(searchWords, (word) => text.indexOf(word) > -1)) &&
        (inRange(creditor.total) || inRange(creditor.deduction) || inRange(creditor.unsecured));
      return {
        ...creditor,
        visible,
      };
    });
    const hasCreditors = creditors.length > 0;
    if (!hasCreditors) {
      return <Well bsSize="small">There is no Largest 20 schedule for this case.</Well>;
    }
    const hasFilteredCreditors = filteredCreditors.filter(({ visible }) => visible).length > 0;
    if (!hasFilteredCreditors) {
      return <Well bsSize="small">No results for searched term, try to search something different.</Well>;
    }
    return (
      <table id="creditors">
        <thead>
          <tr>
            <th rowSpan="2" colSpan="2">
              <span className="label">Creditor name and address</span>
            </th>
            <th rowSpan="2">
              <span className="label">Creditor contact information</span>
            </th>
            <th rowSpan="2">
              <span className="label">Nature of the claim</span>
            </th>
            <th rowSpan="2">
              <span className="label">Indicate if claim is contingent, unliquidated, or disputed</span>
            </th>
            <th colSpan="3">
              <span className="label">Amount of unsecured claim</span>
            </th>
          </tr>
          <tr>
            <th>Total claim, if partially secured</th>
            <th>Deduction for value of collateral or setoff</th>
            <th>Unsecured claim</th>
          </tr>
        </thead>
        <tbody id="view-creditors">
          {filteredCreditors.map((item, key) => (
            <tr key={key} style={{ display: item.visible ? 'table-row' : 'none' }}>
              <td style={{ width: 5 }}>
                <span id="address">{key + 1}</span>
              </td>
              <td style={{ width: 200 }}>
                <span id="address" style={{ whiteSpace: 'pre-wrap' }}>
                  {item.creditor_name}
                  <br />
                  {item.creditor_address_street}
                  <br />
                  {item.creditor_address_city} {item.creditor_address_state} {item.creditor_address_zip_code}
                  <br />
                  {item.creditor_address_country}
                </span>
              </td>
              <td style={{ width: 70 }}>
                <span id="contact" style={{ whiteSpace: 'pre-wrap' }}>
                  {item.contact_address}
                </span>
              </td>
              <td style={{ width: 50 }}>
                <span id="claim-type">{item.claim_type}</span>
              </td>
              <td style={{ width: 50 }}>
                <span id="claim-status">{item.claim_status}</span>
              </td>
              <td className="money">
                <span id="total">{MoneyFormat(item.total)}</span>
              </td>
              <td className="money">
                <span id="deduction">{MoneyFormat(item.deduction)}</span>
              </td>
              <td className="money">
                <span id="deduction">{MoneyFormat(item.unsecured)}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  render() {
    const {
      schedule,
      editScheduleForm,
      can_see_details,
      canEdit,
      toggleScheduleForm,
      onCancel,
      scheduleFiltersProps,
      onSubmit,
      onPastedData,
      type,
    } = this.props;

    const tableData = schedule.data || {};
    const noDataFound = schedule.empty || null;
    const haveSchedule = schedule.data && schedule.data.creditors.length > 0;

    if (noDataFound && !editScheduleForm) {
      return (
        <div id="ir-search-schedule-top20-results">
          <Well bsSize="small">{noDataFound}</Well>
          {canEdit && <ScheduleVerifyToolbar schedule={schedule} />}
          {canEdit && (
            <EditCopyPasteSchedule
              schedule={{ schedule_type: 'top20' }}
              onPastedData={onPastedData}
              toggleScheduleForm={toggleScheduleForm}
            />
          )}
        </div>
      );
    }
    return (
      <div className={type}>
        {can_see_details && (
          <React.Fragment>
            <div id="schedule-top20">
              <div id="ir-search-schedule-top20-results">
                {editScheduleForm ? (
                  <TopTwentyForm
                    {...this.props}
                    // editScheduleForm could be a draft object
                    schedule={editScheduleForm === true ? schedule : editScheduleForm}
                    isDraft={editScheduleForm !== true}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                  />
                ) : (
                  <React.Fragment>
                    {haveSchedule && <ScheduleFilters {...scheduleFiltersProps} />}{' '}
                    {canEdit && <ScheduleVerifyToolbar schedule={schedule} />}
                    {canEdit && (
                      <EditCopyPasteSchedule
                        schedule={schedule}
                        onPastedData={onPastedData}
                        toggleScheduleForm={toggleScheduleForm}
                      />
                    )}
                    {this.getTopTwentydata(tableData)}
                  </React.Fragment>
                )}
                {canEdit && !editScheduleForm && (
                  <div className="editable">
                    <button className="btn btn-primary" onClick={toggleScheduleForm}>
                      Edit
                    </button>
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

TopTwenty.defaultProps = {
  type: 'top20',
  scheduleFiltersProps: {},
  viewFilters: {},
  keyword: '',
  value_from: '',
  value_to: '',
};

TopTwenty.propTypes = {
  schedule: PropTypes.any.isRequired,
  type: PropTypes.string,
  scheduleFiltersProps: PropTypes.object,
  viewFilters: PropTypes.object,
  keyword: PropTypes.string,
  value_to: PropTypes.string,
  value_from: PropTypes.string,
  editScheduleForm: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool.isRequired,
  can_see_details: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  toggleScheduleForm: PropTypes.func.isRequired,
};

export default TopTwenty;



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_top20/TopTwenty.jsx